// extracted by mini-css-extract-plugin
export default {"alignLeft":"ViewAccounts_alignLeft__BIDY5"};